import { createContext, useMemo } from 'react';

import { useGetSiteInfo } from './hooks/useGetSiteInfo';
import { SiteInfo } from './types';
import { useABTest } from './hooks/useABTest';

const SiteInfoContext = createContext<SiteInfo | undefined>(undefined);

const AB_TESTS = [
  {
    variantA: 'useNewDesignSearchForm',
    variantB: 'useNewDesignSearchFormVersion2',
  },
];

const SiteInfoProvider = ({ children }: React.PropsWithChildren) => {
  const siteInfo = useGetSiteInfo();
  const vwoToggles = useABTest(AB_TESTS);

  const context = useMemo(
    () => ({
      ...siteInfo,
      settings: {
        ...siteInfo.settings,
        featureToggles: {
          ...siteInfo.settings.featureToggles,
          ...vwoToggles,
        },
      },
    }),
    [siteInfo, vwoToggles],
  );

  return (
    <SiteInfoContext.Provider value={context}>
      {children}
    </SiteInfoContext.Provider>
  );
};

export { SiteInfoContext, SiteInfoProvider };
